import { PlayerEvent } from "../../events/PlayerEvent.js";
import { PlayerEventAction, PlayerEventsSource } from "../../player/Player.js";


export interface MapperConfigFlags {

    media?: boolean,
    media_progress?: boolean,
    aderrors?: boolean,
    adevents?: boolean

}


/**
 * Abstract base class for mapping and handling player events from a given event source.
 * 
 * `CommonEventMapper` manages the attachment and detachment of event listeners to a `PlayerEventsSource`.
 * Subclasses must implement the `reactToEvents` method to define custom event handling logic.
 * 
 * @remarks
 * - Only one event source and listener can be attached at a time. Attaching a new source will automatically detach the previous listener.
 * - Intended to be extended for specific event mapping requirements.
 * 
 * @example
 * ```typescript
 * class MyEventMapper extends CommonEventMapper {
 *   protected reactToEvents(evt: PlayerEvent): void {
 *     // Custom event handling logic
 *   }
 * }
 * ```
 */
export abstract class CommonEventMapper implements AttachableEventMapper {


    private currentSource: PlayerEventsSource;
    private currentListener: PlayerEventAction;


    constructor() {
        this.currentListener = null;
        this.currentSource = null;
    }
    

    public attachEventSource(evtsrc: PlayerEventsSource): void {
        if(this.currentSource && this.currentListener) {
            this.currentSource.offPlayerEvent(this.currentListener);
        }
        this.currentSource = evtsrc;
        this.currentListener = evtsrc.onPlayerEvent((evt) => this.reactToEvents(evt));
    }


    protected abstract reactToEvents(evt: PlayerEvent): void;
}



export interface AttachableEventMapper {
    attachEventSource(evtsrc: PlayerEventsSource): void;
}